export default __webpack_public_path__ + "static/media/Minesweeper.3f60ffd2.png";